import React from 'react';
import './TermsOfService.css';

const TermsOfService = () => {
  return (
    <div className="terms-of-service-container">
      <h1>Terms of Service</h1>
      <p>Last updated: October 26, 2023</p>

      <h2>1. Acceptance of Terms</h2>
      <p>By accessing and using A/B testing (the "Service"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to all the terms and conditions of this agreement, then you may not access the Service.</p>

      <h2>2. Description of Service</h2>
      <p>A/B testing provides tools for YouTube content creators to perform A/B tests on video thumbnails and analyze their performance. This includes, but is not limited to, uploading multiple thumbnail images, scheduling rotation cycles, and tracking view statistics.</p>

      <h2>3. User Accounts</h2>
      <ul>
        <li>You must be at least 18 years old to use the Service.</li>
        <li>You are responsible for maintaining the confidentiality of your account information.</li>
        <li>You agree to provide accurate and complete information when creating and using your account.</li>
      </ul>

      <h2>4. User Conduct</h2>
      <p>You agree not to use the Service to:</p>
      <ul>
        <li>Upload, post, or transmit any content that is unlawful, harmful, threatening, abusive, defamatory, or otherwise objectionable.</li>
        <li>Impersonate any person or entity.</li>
        <li>Interfere with or disrupt the Service or servers or networks connected to the Service.</li>
        <li>Violate any applicable local, state, national, or international law.</li>
      </ul>

      <h2>5. Intellectual Property</h2>
      <p>The Service and its original content, features, and functionality are and will remain the exclusive property of A/B testing and its licensors. You retain all rights to the content you upload to the Service.</p>

      <h2>6. Termination</h2>
      <p>We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.</p>

      <h2>7. Disclaimers</h2>
      <p>The Service is provided on an "AS IS" and "AS AVAILABLE" basis. A/B testing makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties, including without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.</p>

      <h2>8. Limitation of Liability</h2>
      <p>In no event shall A/B testing or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the Service.</p>

      <h2>9. Governing Law</h2>
      <p>These Terms shall be governed and construed in accordance with the laws of [Your Jurisdiction], without regard to its conflict of law provisions.</p>

      <h2>10. Changes to Terms</h2>
      <p>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. We will provide at least 30 days' notice prior to any new terms taking effect.</p>
    </div>
  );
};

export default TermsOfService;